// removed by extract-text-webpack-plugin
module.exports = {"container":"container___DehEC","wrapper":"wrapper___3C5JH","logo":"logo___2XRC_","info":"info___1e8O7","modal":"modal___3F33i","header":"header___1wbl2","body":"body___hq1qB","close":"close___3ZTrQ","overlay":"overlay___1Dah9","hidden":"hidden___2ezWq"};


//////////////////
// WEBPACK FOOTER
// ./app/components/CheckBox.scss
// module id = 45
// module chunks = 0